export const capitalize = (str) => {
  str = String(str).trim().toLowerCase();
  return str
    .split(/\b/)
    .map(s => (s.charAt(0).toUpperCase() + s.slice(1)))
    .join("")
    .replace(/\bU\./, "u.")
    .replace(/\bI\./, "i.")
    .replace(/\bUnd\b/, "und");
};
